import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import {
  CASH_DRAWER_SHIFT_SUMMARY,
  CASH_DRAWER_LIST_SHIFT,
  CASH_DRAWER_EXPORT_SHIFT,
  CASH_DRAWER_SHIFT_DETAILS,
} from '../constants';

export function getSummary(queryParams) {
  return axios
    .get(CASH_DRAWER_SHIFT_SUMMARY, {
      params: withPaymentConfigFlag(queryParams),
      withCredentials: true,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

export function getShifts(queryParams) {
  return axios
    .get(CASH_DRAWER_LIST_SHIFT, {
      params: withPaymentConfigFlag(queryParams),
      withCredentials: true,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/cash_drawer/shifts_controller.rb#L87
 * @param {object} query
 * @return {Axios.IPromise<U>}
 */
export function exportShift(query) {
  return axios
    .get(CASH_DRAWER_EXPORT_SHIFT, {
      params: withPaymentConfigFlag(query),
      withCredentials: true,
    })
    .catch(error => {
      if (error.response) {
        return Promise.reject(new Error(error.response.data.errors));
      }
      return Promise.reject(new Error(error.message));
    });
}

export function getShiftDetails(shiftId, query) {
  return axios
    .get(CASH_DRAWER_SHIFT_DETAILS(shiftId), {
      params: withPaymentConfigFlag(query),
      withCredentials: true,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

function withPaymentConfigFlag(params) {
  if (hasFeature('enable-payment-configuration')) {
    return params;
  }

  return {
    disablePaymentConfig: true,
    ...params,
  };
}
